import { inject, Injectable } from '@angular/core';
import { ApiRouteInspectionService } from 'src/app/api/elite/routes/inspection.service';
import { forkJoin, map, switchMap } from 'rxjs';
import { APIRouteCompressionViewCobotItemService } from 'src/app/features/compression/view-cobot/api/cobot-item.service';
import { CobotUpdateManuallyCams } from 'src/app/features/compression/view-cobot/types/cobot-update-manually-cams';
import { Inspection } from 'src/app/api/elite/types/inspections';
import { ApiRouteInspectionVisualService } from 'src/app/api/elite/routes/inspection-visual.service';

@Injectable()
export class InspectionCobotService {
  private readonly apiCobotService = inject(
    APIRouteCompressionViewCobotItemService
  );
  private readonly apiInspectionService = inject(ApiRouteInspectionService);
  private readonly apiVisualRecordService = inject(
    ApiRouteInspectionVisualService
  );
  private apiInspectionVisualService = inject(ApiRouteInspectionVisualService);

  startFinishedCobotInspection(data: {
    bodyCobotUpdate: CobotUpdateManuallyCams[];
    workOrderId: number;
    quantity: number;
    quantityErrors: number;
    packingBoxId: number;
    assemblyTitle: string;
    inspection: Inspection;
  }) {
    const {
      bodyCobotUpdate,
      workOrderId,
      quantity,
      quantityErrors,
      packingBoxId,
      assemblyTitle,
      inspection,
    } = data;

    return forkJoin([
      //* Create a record for bad pieces
      //* Scrap reason 'Material Defectuoso' is 32
      this.apiVisualRecordService.createRecord(inspection.id, {
        inspectionId: inspection.id,
        quantity: quantityErrors,
        scrapId: 32,
        rejectedPoint: true,
      }),

      //* Create a record for good pieces
      //* Scrap reason is null
      this.apiVisualRecordService.createRecord(inspection.id, {
        inspectionId: inspection.id,
        quantity: quantity - quantityErrors,
      }),
    ]).pipe(
      switchMap((res) => {
        //* Partial finish for InspectionVisualDetails and InspectionVisualRecords
        return this.apiInspectionVisualService.finishPartial(inspection.id, {
          scrapReasons: [],
        });
      }),
      switchMap((res) => {
        //* Finish the inspection
        return this.apiInspectionService.finishInspection(
          inspection.id,
          'Ths inspection was created by the cobots',
          {
            ifFailsSendTo: 'Rejected from QC',
            ifSucessSendTo: 'Validation',
          }
        );
      }),
      switchMap(({ passed, quantityToRemove }) => {
        return forkJoin(
          bodyCobotUpdate.map((item) => {
            //* Assign the inspection id to the cobot
            item.inspectionId = inspection.id;
            return this.apiCobotService.updateInspection(item);
          })
        ).pipe(
          map(() => {
            return {
              inspectionId: inspection.id,
              passed,
              quantityToRemove,
            };
          })
        );
      })
    );
  }
}
